const publicityteam = [
    {
        name: "Anusshka Choudhary",
        title: "Publicity",
        imageSrc: "/images/committee/publicity/Anusshka_choudhary.jpg",
        socials:{},
    },
    {
        name: "Jatin Pandey",
        title: "Publicity",
        imageSrc: "/images/committee/publicity/Jatin_Pandey.jpg",
        socials: {},
    },
    {
        name: "Sanjal Ghate",
        title: "Publicity",
        imageSrc: "/images/committee/publicity/Sanjal_Ghate.jpg",
        socials:{},
    },
    
]

export default publicityteam;